function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}.cls-2{fill:none;}.cls-3{fill:#a67c52;}.cls-4{fill:#8cc63f;}.cls-5{fill:#25c;}.cls-6{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logoSvg");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "cube"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M200.88,130.92q0,35.09,0,70.17a4.63,4.63,0,0,0,2.08,4.33q71.3,50.77,142.5,101.66c1.61,1.15,2.66,1.17,4.28,0q71.2-50.9,142.43-101.77a5.54,5.54,0,0,0,2-3.91q.15-70.33.13-140.67c0-2-.52-3-2.57-3.75Q420.8,31.6,349.91,6.12a7.5,7.5,0,0,0-4.67,0Q274.46,31.44,203.72,56.87c-2.29.82-2.89,1.94-2.89,4.2C200.92,84.36,200.89,107.64,200.88,130.92Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M196.63,130.87c0-24.34,0-48.69,0-73,0-2.37.62-3.54,3-4.4Q272.19,27,344.8.39a7.57,7.57,0,0,1,4.79,0q72.8,26.54,145.57,53.2c2.1.77,2.64,1.83,2.63,3.92q-.08,73.53-.13,147.07a5.82,5.82,0,0,1-2.08,4.09q-73,53.27-146.19,106.4c-1.67,1.21-2.74,1.19-4.39,0q-73.09-53.21-146.27-106.29a4.87,4.87,0,0,1-2.13-4.53Q196.67,167.55,196.63,130.87ZM341,297.05c.08-1.27.19-2.12.19-3q0-77.9.08-155.8c0-2.54-1.11-3.49-3.07-4.48q-63-31.73-126-63.55c-1-.53-2.14-1-3.58-1.62V72.9q0,62.19-.07,124.37a6.6,6.6,0,0,0,3.1,6.08q63.2,45.79,126.3,91.7C338.82,295.69,339.75,296.24,341,297.05Zm12.22.16c1.22-.78,1.88-1.16,2.49-1.61q64-46.47,127.93-92.91a4.87,4.87,0,0,0,2.19-4.49q-.08-63.2,0-126.4c0-.93-.16-1.87-.27-3.06-1.37.64-2.39,1.07-3.38,1.57Q419.27,102,356.4,133.67c-2.45,1.23-3.27,2.65-3.26,5.39q.13,77.05.06,154.11ZM218,59.55c1.1.65,1.56,1,2,1.2Q282.55,92.33,345.08,124c2,1,3.36.39,5-.42l123-62.1c1-.5,1.94-1.05,3.28-1.79-1.32-.55-2.21-1-3.13-1.29Q411.53,35.76,349.84,13.24a8.59,8.59,0,0,0-5.42.05Q302.2,28.6,260.07,44.13Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M346,296.18c-1.28-.82-2.25-1.38-3.15-2q-65.47-46.53-131-93a6.66,6.66,0,0,1-3.22-6.17c.09-35.29.07-119.41.07-126.18V64.44c1.49.66,2.63,1.1,3.71,1.64q65.31,32.24,130.63,64.47c2,1,3.18,2,3.18,4.55,0,8.35-.07,113.73-.08,158.07C346.17,294,346.06,294.89,346,296.18Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M349.82,297.21v-4.14q0-78.8-.07-157.6c0-2.79.83-4.25,3.35-5.51Q417.6,97.65,482,65.17c1-.51,2.06-1,3.47-1.61.11,1.22.27,2.18.27,3.13q0,64.63.05,129.26a5,5,0,0,1-2.24,4.6q-65.63,47.46-131.19,95C351.74,296,351.07,296.41,349.82,297.21Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M212.22,61.68l44-15.83q44-15.87,88.09-31.66a9.11,9.11,0,0,1,5.66-.06q64.44,23.06,128.81,46.34c1,.35,1.89.76,3.27,1.33-1.41.76-2.4,1.33-3.43,1.84L350.16,127.41c-1.68.83-3.09,1.48-5.19.44Q279.71,95.29,214.36,62.92C213.85,62.66,213.37,62.35,212.22,61.68Z",
  transform: "translate(-0.25)"
})), /*#__PURE__*/React.createElement("g", {
  id: "title"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M694.12,143.75v23.92a9.52,9.52,0,0,1-2.86,6.76l-6.76,6.82a9,9,0,0,1-6.5,2.67H644.59V141.21l6.76-6.82h33.34A9.38,9.38,0,0,1,694.12,143.75Zm-1.3,24v-24a8.07,8.07,0,0,0-8.13-8.06h-32v40.17h32.11A8.08,8.08,0,0,0,692.82,167.73Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M692.82,143.75v24a8.08,8.08,0,0,1-8.06,8.13H652.65V135.69h32A8.07,8.07,0,0,1,692.82,143.75Zm-16.25,23.66V144.07h-7.74v23.34Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 668.58,
  y: 144.07,
  width: 7.74,
  height: 23.34
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "641.02 135.69 641.09 177.09 634.26 183.92 616.39 183.92 614.7 179.63 610.47 183.92 591.69 183.92 591.69 141.21 598.45 134.39 618.14 134.39 618.44 135.28 617.23 135.69 599.75 135.69 599.75 175.86 616 175.86 616 155.9 616.45 155.97 623.8 175.86 639.72 175.86 639.72 135.69 641.02 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "641.02 134.39 641.02 135.69 639.72 135.69 623.73 135.69 623.73 153.76 623.15 153.82 617.23 135.69 618.44 135.28 619.25 137.64 622.43 134.39 641.02 134.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "639.72 135.69 639.72 175.86 623.8 175.86 616.45 155.97 616 155.9 616 175.86 599.75 175.86 599.75 135.69 617.23 135.69 623.15 153.82 623.73 153.76 623.73 135.69 639.72 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "588.44 134.39 588.44 177.16 581.74 183.92 562.89 183.92 562.89 178.85 562.89 175.86 563.28 175.86 563.28 160.06 570.95 160.06 570.95 175.86 587.07 175.86 587.07 135.69 587.07 134.39 588.44 134.39"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M587.32,135.69v40.17H571.2v-15.8h-7.67v15.8H547.22V135.69ZM571.2,151.61v-7.47h-7.67v7.47Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "587.07 134.39 587.07 135.69 546.97 135.69 546.97 175.86 562.89 175.86 562.89 178.85 557.82 183.92 538.91 183.92 538.91 141.21 545.67 134.39 587.07 134.39"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 563.28,
  y: 144.14,
  width: 7.67,
  height: 7.47
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M535.91,166.17v11l-6.83,6.76h-42.7V141.21l6.76-6.82h18.91v31.78Zm-1.3,9.69v-8.39H510.75V135.69H494.5v40.17Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "534.36 167.47 534.36 175.86 494.25 175.86 494.25 135.69 510.5 135.69 510.5 167.47 534.36 167.47"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M483.13,159.61v8.06a9.48,9.48,0,0,1-2.6,6.56l-.13.13-.89-.88a8.18,8.18,0,0,0,2.32-5.75v-8.12a8.08,8.08,0,0,0-8.06-8.13H458.1v-7.41h19.44v-8.38H450a8.21,8.21,0,0,0-6.05,2.66l-.91-.9.26-.27a9.3,9.3,0,0,1,6.7-2.79h28.86v11l-4.75,4.81C479.16,150.18,483.13,154.73,483.13,159.61Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M481.83,159.61v8.12a8.18,8.18,0,0,1-2.32,5.75,7.9,7.9,0,0,1-5.68,2.38H445.62v-8.39h20V160H441.79V143.81a8,8,0,0,1,2.14-5.46,8.21,8.21,0,0,1,6.05-2.66h27.56v8.38H458.1v7.41h15.67A8.08,8.08,0,0,1,481.83,159.61Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M480.4,174.36l-6.63,6.7a9.24,9.24,0,0,1-6.7,2.86H437.56V173l4.94-4.88h-8.77V150.64a9.38,9.38,0,0,1,2.79-6.63l6.5-6.56.91.9a8,8,0,0,0-2.14,5.46V160h23.85v7.47h-20v8.39h28.21a7.9,7.9,0,0,0,5.68-2.38Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M430.48,163.7V177l-6.76,6.89H404.93v-8.06h.39V160H413v15.86h16.18V163.7a8.16,8.16,0,0,0-1-4l1.17-.54A9.24,9.24,0,0,1,430.48,163.7Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M430.48,143.81v4a9.54,9.54,0,0,1-4.29,8,9.45,9.45,0,0,1,3.12,3.32l-1.17.54a7.91,7.91,0,0,0-5.27-3.86,8.11,8.11,0,0,0,6.31-8v-4a8.07,8.07,0,0,0-8.06-8.12H389.07v40.17h15.86v2.86l-5.07,5.2H381V141.21l6.76-6.82h33.35A9.37,9.37,0,0,1,430.48,143.81Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M429.18,163.7v12.16H413V160h-7.68v15.86H389.07V135.69h32.05a8.07,8.07,0,0,1,8.06,8.12v4a8.11,8.11,0,0,1-6.31,8,7.91,7.91,0,0,1,5.27,3.86A8.16,8.16,0,0,1,429.18,163.7ZM413,151.55v-7.48h-7.68v7.48Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 405.07,
  y: 144.07,
  width: 7.68,
  height: 7.48
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "375.24 167.54 375.24 177.03 368.48 183.92 325.77 183.92 325.77 141.15 332.53 134.39 375.24 134.39 375.24 135.69 373.94 135.69 333.83 135.69 333.83 175.86 373.94 175.86 373.94 167.54 375.24 167.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "375.24 166.24 375.24 167.54 373.94 167.54 350.08 167.54 350.08 160 371.6 160 371.6 151.55 372.9 151.55 372.9 161.3 367.96 166.24 375.24 166.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "375.24 135.69 375.24 145.37 370.37 150.25 372.9 150.25 372.9 151.55 371.6 151.55 350.08 151.55 350.08 144.07 373.94 144.07 373.94 135.69 375.24 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "373.94 167.54 373.94 175.86 333.83 175.86 333.83 135.69 373.94 135.69 373.94 144.07 350.08 144.07 350.08 151.55 371.6 151.55 371.6 160 350.08 160 350.08 167.54 373.94 167.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "320.25 134.39 320.25 177.09 313.56 183.92 294.71 183.92 294.71 166.5 293.34 167.86 289.05 167.86 287.75 167.86 287.75 152.46 291.13 159.74 299.26 159.74 302.77 152.07 302.77 175.86 318.95 175.86 318.95 135.69 302.44 135.69 295.16 151.29 287.81 135.69 287.81 134.39 288.66 134.39 293.41 144.46 294.84 141.21 301.6 134.39 320.25 134.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "318.95 135.69 318.95 175.86 302.77 175.86 302.77 152.07 299.26 159.74 291.13 159.74 287.75 152.46 287.75 167.86 287.75 175.86 271.5 175.86 271.5 135.69 287.81 135.69 295.16 151.29 302.44 135.69 318.95 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "289.05 167.86 289.05 177.09 282.35 183.92 263.44 183.92 263.44 141.15 270.2 134.39 287.81 134.39 287.81 135.69 271.5 135.69 271.5 175.86 287.75 175.86 287.75 167.86 289.05 167.86"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "262.47 134.39 262.47 177.16 255.77 183.92 236.92 183.92 236.92 178.85 236.92 175.86 237.31 175.86 237.31 160.06 244.98 160.06 244.98 175.86 261.1 175.86 261.1 135.69 261.1 134.39 262.47 134.39"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M261.35,135.69v40.17H245.23v-15.8h-7.67v15.8H221.25V135.69Zm-16.12,15.92v-7.47h-7.67v7.47Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "261.1 134.39 261.1 135.69 221 135.69 221 175.86 236.92 175.86 236.92 178.85 231.85 183.92 212.93 183.92 212.93 141.21 219.7 134.39 261.1 134.39"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 237.31,
  y: 144.14,
  width: 7.67,
  height: 7.47
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "207.41 167.54 207.41 177.03 200.65 183.92 157.94 183.92 157.94 141.15 164.71 134.39 207.41 134.39 207.41 135.69 206.11 135.69 166.01 135.69 166.01 175.86 206.11 175.86 206.11 167.54 207.41 167.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "207.41 166.24 207.41 167.54 206.11 167.54 182.26 167.54 182.26 160 203.77 160 203.77 151.55 205.07 151.55 205.07 161.3 200.13 166.24 207.41 166.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "207.41 135.69 207.41 145.37 202.54 150.25 205.07 150.25 205.07 151.55 203.77 151.55 182.26 151.55 182.26 144.07 206.11 144.07 206.11 135.69 207.41 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "206.11 167.54 206.11 175.86 166.01 175.86 166.01 135.69 206.11 135.69 206.11 144.07 182.26 144.07 182.26 151.55 203.77 151.55 203.77 160 182.26 160 182.26 167.54 206.11 167.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M155,163.7V177l-6.76,6.89H129.4v-8.06h.39V160h7.67v15.86h16.19V163.7a8.16,8.16,0,0,0-1-4l1.17-.54A9.24,9.24,0,0,1,155,163.7Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M155,143.81v4a9.54,9.54,0,0,1-4.29,8,9.45,9.45,0,0,1,3.12,3.32l-1.17.54a8,8,0,0,0-5.27-3.86,8.12,8.12,0,0,0,6.31-8v-4a8.07,8.07,0,0,0-8.06-8.12H113.54v40.17H129.4v2.86l-5.07,5.2H105.48V141.21l6.76-6.82h33.35A9.37,9.37,0,0,1,155,143.81Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M153.65,163.7v12.16H137.46V160h-7.67v15.86H113.54V135.69h32.05a8.07,8.07,0,0,1,8.06,8.12v4a8.12,8.12,0,0,1-6.31,8,8,8,0,0,1,5.27,3.86A8.16,8.16,0,0,1,153.65,163.7Zm-16.19-12.15v-7.48h-7.67v7.48Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 129.54,
  y: 144.07,
  width: 7.67,
  height: 7.48
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "101.98 135.69 101.98 145.37 95.22 152.2 90.15 152.2 88.85 152.2 88.85 144.07 100.68 144.07 100.68 135.69 101.98 135.69"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "101.98 134.39 101.98 135.69 100.68 135.69 60.71 135.69 60.71 144.07 72.6 144.07 72.6 175.86 88.85 175.86 88.85 152.2 90.15 152.2 90.15 177.03 83.39 183.92 64.48 183.92 64.48 152.2 52.65 152.2 52.65 141.21 59.47 134.39 101.98 134.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "100.68 135.69 100.68 144.07 88.85 144.07 88.85 152.2 88.85 175.86 72.6 175.86 72.6 144.07 60.71 144.07 60.71 135.69 100.68 135.69"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M49.65,159.61v8.06a9.48,9.48,0,0,1-2.6,6.56l-.13.13-.89-.88a8.18,8.18,0,0,0,2.32-5.75v-8.12a8.08,8.08,0,0,0-8.06-8.13H24.62v-7.41H44.06v-8.38H16.5a8.21,8.21,0,0,0-6,2.66l-.91-.9.26-.27a9.3,9.3,0,0,1,6.7-2.79H45.36v11l-4.75,4.81C45.68,150.18,49.65,154.73,49.65,159.61Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M48.35,159.61v8.12A8.18,8.18,0,0,1,46,173.48a7.9,7.9,0,0,1-5.68,2.38H12.14v-8.39h20V160H8.31V143.81a8,8,0,0,1,2.14-5.46,8.21,8.21,0,0,1,6-2.66H44.06v8.38H24.62v7.41H40.29A8.08,8.08,0,0,1,48.35,159.61Z",
  transform: "translate(-0.25)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M46.92,174.36l-6.63,6.7a9.24,9.24,0,0,1-6.7,2.86H4.08V173L9,168.12H.25V150.64A9.38,9.38,0,0,1,3,144l6.5-6.56.91.9a8,8,0,0,0-2.14,5.46V160H32.16v7.47h-20v8.39H40.35A7.9,7.9,0,0,0,46,173.48Z",
  transform: "translate(-0.25)"
})));

var SvgStreamersland = function SvgStreamersland(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 693.87 315.97",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStreamersland, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/streamersland.fe44f735.svg";
export { ForwardRef as ReactComponent };